import StructuredData from './StructuredData'
import { usePricingTiers } from '@/hooks/usePricingTiers'

const SITE_URL = 'https://www.wealthspace.co.uk'

export default function PricingSchema() {
  const { tiers } = usePricingTiers()

  const offers = tiers
    .filter((t) => typeof t.monthlyPrice === 'number')
    .map((t) => ({
      name: `${t.displayName} plan`,
      description: t.description,
      price: String(t.monthlyPrice),
      priceCurrency: 'GBP',
      url: `${SITE_URL}/pricing#${t.slug}`,
    }))

  if (offers.length === 0) return null

  return (
    <StructuredData
      data={{
        type: 'Product',
        name: 'WealthSpace adviser software',
        description:
          'Modular AI-powered practice management software for UK financial advisers: recordings, AI reports, client management, compliance, and more.',
        url: `${SITE_URL}/pricing`,
        brand: 'WealthSpace',
        offers,
      }}
    />
  )
}
